import * as React from 'react';
import { connect } from 'react-redux';
import store from '../store/store';
import types from '../store/types';
import { RedirectConfig, RedirectCandidateSearch } from '../components';
import { PropertyHelper, EModalType, ModalHelper, IRedirectConfigState, IRedirectCandidate, ERedirectCandidateType, getRedirectCandidates, IComponent, OutputsHelper, 
	IOutputValue, IOption, clone } from '../helpers';
import { REDIRECT_CANDIDATE_TYPE_PROPERTY_LABEL, REDIRECT_CANDIDATE_TYPE_PROPERTY_NAME, QUERY_STRING_PROPERTY_NAME } 
	from '../constants';
import { IDropdownOption } from 'office-ui-fabric-react';
import redirectConfigReducer from '../store/reducers/redirect-config';

interface IRedirectConfigContainerProps {
	state: IRedirectConfigState;
	components: IComponent[];
	outputs: IOutputValue[];
	candidateTypeOptions: IOption[];
	candidateTypeTemplates: {[type: number]: IRedirectCandidate};
}

class RedirectConfigContainer extends React.Component<IRedirectConfigContainerProps, {}> {

	updateProperty = (key:string, value:any) => {

		let { redirect } = this.props.state;

		redirect = PropertyHelper.updateProperty(redirect, key, value);

		store.dispatch({
            type: types.UPDATE_REDIRECT_DIALOG,
            redirect: redirect
        });

    }

	closeDialog = (save?: boolean) => {

        let { state } = this.props;

        if (save) {
			
			let errorMessages: string[] = this.getErrorMessages();

			if(errorMessages.length) {
		
				store.dispatch({
					type: types.SET_MODAL_ERROR_MESSAGES,
					errorMessages: errorMessages
				});

				//scroll to the top of the dialog so that the error message is visible
                ModalHelper.scrollToErrorDisplay();

			}
			else {

				//save the redirect component
				store.dispatch({
					type: types.UPDATE_REDIRECT,
					componentId: state.componentId,
					redirect: state.redirect
				});

				this.closeModal();
			}

        }
		else {
			this.closeModal();
		}

	}
	
	closeModal = () => {

		// Clear the modal state
		store.dispatch({
			type: types.SET_SELECTED_REDIRECT_CANDIDATE,
			selectedCandidate: null
		});

		
		store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
	}

	getErrorMessages = (): string[] => {

		let { redirect, redirectCandidateResults, selectedCandidate } = this.props.state;

		let clonedProperties = clone(redirect.Properties);
		// replace the name of the To property with the text in its label
		clonedProperties = clonedProperties.map(p => {
			if(p.Name === REDIRECT_CANDIDATE_TYPE_PROPERTY_NAME) {
				p.Name = REDIRECT_CANDIDATE_TYPE_PROPERTY_LABEL;
			}
			return p;
		});

		if(selectedCandidate && selectedCandidate.Properties) {
			clonedProperties = clonedProperties.concat(selectedCandidate.Properties);
		}

		let propertyErrors = PropertyHelper.getErrorMessages(clonedProperties, false);

		return propertyErrors;
	}

	setSelectedRedirectCandidate = (candidate: IRedirectCandidate) => {
		store.dispatch({
			type: types.SET_SELECTED_REDIRECT_CANDIDATE,
			selectedCandidate: candidate
		});
		
		this.updateProperty(REDIRECT_CANDIDATE_TYPE_PROPERTY_NAME, candidate);
	}

	onSearchResultClicked = (candidate: IRedirectCandidate) => {
		this.setSelectedRedirectCandidate(candidate);
		this.updateSearchResults("");
	}
	
    onCandidateTypeChanged = (option: IDropdownOption, index?: number) => {
		
		let { candidateTypeTemplates, state } = this.props;
		let template = candidateTypeTemplates[option.key];
		this.setSelectedRedirectCandidate(template);
	};

	onCandidatePropertyChanged = (name: string, value: string, componentId: string) => {
		let { redirect } = this.props.state;
		if(redirect && redirect.Properties) {
			let to = PropertyHelper.getPropertyValue(redirect.Properties, REDIRECT_CANDIDATE_TYPE_PROPERTY_NAME);
			if(to) {
				to = PropertyHelper.updateProperty(to, name, value);
				this.setSelectedRedirectCandidate(to);
			}
		}		
	};
	
	updateSearchResults = (term: string) => {

		let searchTerm = term || '';

		if(searchTerm) {
			store.dispatch({
				type: types.SET_REDIRECT_CANDIDATE_SEARCH,
				awaitingResults: true,
				redirectCandidateResults: [],
				term: searchTerm,
			});

			getRedirectCandidates(searchTerm).then((results: IRedirectCandidate[]) => {
				store.dispatch({
					type: types.SET_REDIRECT_CANDIDATE_SEARCH,
					redirectCandidateResults: results,
					awaitingResults: false,
					term: searchTerm,			
				});
			});
		}
		else {
			store.dispatch({
				type: types.SET_REDIRECT_CANDIDATE_SEARCH,
				awaitingResults: false,
				redirectCandidateResults: [],
				term: searchTerm,
			});
		}
	}

	componentDidMount() {
		
		let { redirect } = this.props.state;
		if(redirect && redirect.Properties) {
			let to = PropertyHelper.getPropertyValue(redirect.Properties, REDIRECT_CANDIDATE_TYPE_PROPERTY_NAME);
			if(to) {
				this.setSelectedRedirectCandidate(to);
			}
		}
	}

	public render() {
		
		let { outputs, candidateTypeOptions } = this.props;
		let { redirect, componentId, term, redirectCandidateResults, selectedCandidate, awaitingResults, previousOutputBlocks } = this.props.state;
		
		let outputOptions = OutputsHelper.getOutputDropdownOptions(outputs, previousOutputBlocks);
		return (<div>	
			<RedirectConfig 
				componentId={componentId}
				onSearchBlur={() => {}}
				onSearchResultClicked={this.onSearchResultClicked}
				updateSearchResults={this.updateSearchResults}
				selectedCandidate={selectedCandidate}
				term={term}
				redirectCandidateResults={redirectCandidateResults}
				awaitingResults={awaitingResults}
				redirect={ redirect }
				closeDialog={ this.closeDialog }
				updateProperty={ this.updateProperty }
				queryString={PropertyHelper.getPropertyValue(redirect.Properties, QUERY_STRING_PROPERTY_NAME)}
				onQueryStringChange={(queryString) => {
					this.updateProperty(QUERY_STRING_PROPERTY_NAME, queryString);
				}}
				outputOptions={outputOptions}
				candidateTypeOptions={candidateTypeOptions}
				onCandidatePropertyChanged={this.onCandidatePropertyChanged}
				onCandidateTypeChanged={this.onCandidateTypeChanged}
			/>
		</div>);
	}

}

let mapStateToProps = (store) => {

	return {
		state: store.modalState.redirectConfig,
		outputs: OutputsHelper.CombineOutputs(store.outputsState.outputs, store.outputsState.globalOutputs),
		components: store.processState.components,
		candidateTypeOptions: store.cacheState.redirectCandidateTypeOptions,
		candidateTypeTemplates: store.cacheState.redirectCandidateTemplates
	};
};

export default connect<any, any, any>(mapStateToProps)(RedirectConfigContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/redirect-config.tsx